import React from 'react';
import { Card, useColorModeValue } from '@chakra-ui/react';

export const PirateCard = ({ children, ...props }) => {
  const borderColor = useColorModeValue('rgba(255, 215, 0, 0.3)', 'rgba(255, 215, 0, 0.2)');
  const bgColor = useColorModeValue('white', 'gray.800');
  const shadowColor = useColorModeValue('rgba(255, 215, 0, 0.1)', 'rgba(255, 215, 0, 0.05)');

  return (
    <Card
      {...props}
      bg={bgColor}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="xl"
      boxShadow={`0 4px 12px ${shadowColor}`}
      transition="all 0.3s ease"
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: `0 8px 16px ${shadowColor}`,
      }}
    >
      {children}
    </Card>
  );
};
